import { render, staticRenderFns } from "./WarrantyDetailsContainer.vue?vue&type=template&id=392e52cb&"
import script from "./WarrantyDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./WarrantyDetailsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports